import { Dropdown } from "semantic-ui-react";
export const ukcounties = [
  {
    text: "header1",
    value: "header1",
    content: <Dropdown.Header>England</Dropdown.Header>,
    disabled: true,
  },
  { text: "Bedfordshire", value: "Bedfordshire" },
  { text: "Berkshire", value: "Berkshire" },
  { text: "Bristol", value: "Bristol" },
  { text: "Buckinghamshire", value: "Buckinghamshire" },
  { text: "Cambridgeshire", value: "Cambridgeshire" },
  { text: "Cheshire", value: "Cheshire" },
  { text: "City of London", value: "City of London" },
  { text: "Cornwall", value: "Cornwall" },
  { text: "Cumbria", value: "Cumbria" },
  { text: "Derbyshire", value: "Derbyshire" },
  { text: "Devon", value: "Devon" },
  { text: "Dorset", value: "Dorset" },
  { text: "Durham", value: "Durham" },
  { text: "East Riding of Yorkshire", value: "East Riding of Yorkshire" },
  { text: "East Sussex", value: "East Sussex" },
  { text: "Essex", value: "Essex" },
  { text: "Gloucestershire", value: "Gloucestershire" },
  { text: "Greater London", value: "Greater London" },
  { text: "Greater Manchester", value: "Greater Manchester" },
  { text: "Hampshire", value: "Hampshire" },
  { text: "Herefordshire", value: "Herefordshire" },
  { text: "Hertfordshire", value: "Hertfordshire" },
  { text: "Isle of Wight", value: "Isle of Wight" },
  { text: "Kent", value: "Kent" },
  { text: "Lancashire", value: "Lancashire" },
  { text: "Leicestershire", value: "Leicestershire" },
  { text: "Lincolnshire", value: "Lincolnshire" },
  { text: "Merseyside", value: "Merseyside" },
  { text: "Norfolk", value: "Norfolk" },
  { text: "North Yorkshire", value: "North Yorkshire" },
  { text: "Northamptonshire", value: "Northamptonshire" },
  { text: "Northumberland", value: "Northumberland" },
  { text: "Nottinghamshire", value: "Nottinghamshire" },
  { text: "Oxfordshire", value: "Oxfordshire" },
  { text: "Rutland", value: "Rutland" },
  { text: "Shropshire", value: "Shropshire" },
  { text: "Somerset", value: "Somerset" },
  { text: "South Yorkshire", value: "South Yorkshire" },
  { text: "Staffordshire", value: "Staffordshire" },
  { text: "Suffolk", value: "Suffolk" },
  { text: "Surrey", value: "Surrey" },
  { text: "Tyne and Wear", value: "Tyne and Wear" },
  { text: "Warwickshire", value: "Warwickshire" },
  { text: "West Midlands", value: "West Midlands" },
  { text: "West Sussex", value: "West Sussex" },
  { text: "West Yorkshire", value: "West Yorkshire" },
  { text: "Wiltshire", value: "Wiltshire" },
  { text: "Worcestershire", value: "Worcestershire" },
  {
    text: "header1",
    value: "header1",
    content: <Dropdown.Header>Scotland</Dropdown.Header>,
    disabled: true,
  },
  { text: "Aberdeen City", value: "Aberdeen City" },
  { text: "Aberdeenshire", value: "Aberdeenshire" },
  { text: "Angus", value: "Angus" },
  { text: "Argyll and Bute", value: "Argyll and Bute" },
  { text: "Clackmannanshire", value: "Clackmannanshire" },
  { text: "Dumfries and Galloway", value: "Dumfries and Galloway" },
  { text: "Dundee City", value: "Dundee City" },
  { text: "East Ayrshire", value: "East Ayrshire" },
  { text: "East Dunbartonshire", value: "East Dunbartonshire" },
  { text: "East Lothian", value: "East Lothian" },
  { text: "East Renfrewshire", value: "East Renfrewshire" },
  { text: "Edinburgh (City of)", value: "Edinburgh (City of)" },
  { text: "Falkirk", value: "Falkirk" },
  { text: "Fife", value: "Fife" },
  { text: "Glasgow City", value: "Glasgow City" },
  { text: "Highland", value: "Highland" },
  { text: "Inverclyde", value: "Inverclyde" },
  { text: "Midlothian", value: "Midlothian" },
  { text: "Moray", value: "Moray" },
  {
    text: "Na h-Eileanan Siar (Western Isles)",
    value: "Na h-Eileanan Siar (Western Isles)",
  },
  { text: "North Ayrshire", value: "North Ayrshire" },
  { text: "North Lanarkshire", value: "North Lanarkshire" },
  { text: "Orkney Islands", value: "Orkney Islands" },
  { text: "Perth and Kinross", value: "Perth and Kinross" },
  { text: "Renfrewshire", value: "Renfrewshire" },
  { text: "Scottish Borders", value: "Scottish Borders" },
  { text: "Shetland Islands", value: "Shetland Islands" },
  { text: "South Ayrshire", value: "South Ayrshire" },
  { text: "South Lanarkshire", value: "South Lanarkshire" },
  { text: "Stirling", value: "Stirling" },
  { text: "West Dunbartonshire", value: "West Dunbartonshire" },
  { text: "West Lothian", value: "West Lothian" },
  {
    text: "header1",
    value: "header1",
    content: <Dropdown.Header>Wales</Dropdown.Header>,
    disabled: true,
  },
  { text: "Blaenau Gwent", value: "Blaenau Gwent" },
  { text: "Bridgend", value: "Bridgend" },
  { text: "Caerphilly", value: "Caerphilly" },
  { text: "Cardiff", value: "Cardiff" },
  { text: "Carmarthenshire", value: "Carmarthenshire" },
  { text: "Ceredigion", value: "Ceredigion" },
  { text: "Conwy", value: "Conwy" },
  { text: "Denbighshire", value: "Denbighshire" },
  { text: "Flintshire", value: "Flintshire" },
  { text: "Gwynedd", value: "Gwynedd" },
  { text: "Isle of Anglesey", value: "Isle of Anglesey" },
  { text: "Merthyr Tydfil", value: "Merthyr Tydfil" },
  { text: "Monmouthshire", value: "Monmouthshire" },
  { text: "Neath Port Talbot", value: "Neath Port Talbot" },
  { text: "Newport", value: "Newport" },
  { text: "Pembrokeshire", value: "Pembrokeshire" },
  { text: "Powys", value: "Powys" },
  { text: "Rhondda Cynon Taf", value: "Rhondda Cynon Taf" },
  { text: "Swansea", value: "Swansea" },
  { text: "Torfaen", value: "Torfaen" },
  { text: "Vale of Glamorgan", value: "Vale of Glamorgan" },
  { text: "Wrexham", value: "Wrexham" },
  {
    text: "header1",
    value: "header1",
    content: <Dropdown.Header>Northern Ireland</Dropdown.Header>,
    disabled: true,
  },
  { text: "Antrim", value: "Antrim" },
  { text: "Armagh", value: "Armagh" },
  { text: "Down", value: "Down" },
  { text: "Fermanagh", value: "Fermanagh" },
  { text: "Londonderry", value: "Londonderry" },
  { text: "Tyrone", value: "Tyrone" },
  { text: "Belfast", value: "Belfast" },
  { text: "Derry", value: "Derry" },
];
